import React from 'react';
import { css } from '@emotion/css';
import { css as reactCss } from '@emotion/react';
import Modal from 'react-modal';

import { mediaQueries } from '~src/main/theme/media-queries';

interface DialogProps {
  height?: number;
  width?: number;
  onClose: () => void;
}

export const Dialog: React.FC<DialogProps> = ({
  children,
  height,
  width,
  /*
   * Skip event param in call to this function. This function will be usually
   * the rpc skeleton from fullscreen-internals, but we cannot and do not need
   * to serialize events.
   */
  onClose,
}) => {
  const style = {
    content: {
      height,
      width,
    },
  };

  return (
    <Modal
      className={css(styles.content)}
      isOpen
      overlayClassName={css(styles.overlay)}
      style={style}
      onRequestClose={() => onClose()}
    >
      {children}
    </Modal>
  );
};

const styles = {
  content: reactCss({
    backgroundColor: 'white',
    border: 'none',
    maxHeight: 'calc(-24px + 100vh)',
    maxWidth: 'calc(-24px + 100vw)',
    outline: 'none',
    position: 'relative',
    [mediaQueries.S]: {
      height: '100vh !important',
      width: '100vw !important',
      maxHeight: 'initial',
      maxWidth: 'initial',
    },
  }),
  overlay: reactCss({
    backgroundColor: 'rgba(24, 27, 27, 0.8)',
    position: 'fixed',
    bottom: '0',
    left: '0',
    right: '0',
    top: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
};
